import { KeyValuePair } from "../key-value-pair";

export class ContactConstants {

    public static EMAIL: string = "Email";
    public static PHONE: string = "Phone";

    public static ContactOptions: KeyValuePair[] = [
        {key: this.EMAIL, value: this.EMAIL},
        {key: this.PHONE, value: this.PHONE}
    ]
}